import { GpsTriggerVisitedStore } from "./GpsTriggerVisitedStore";

const states = new WeakMap<HTMLElement, Map<string, GpsTriggerVisitedStore>>();

export function getGpsTriggerVisitedStore(root: HTMLElement, storage: Storage | undefined, storageKey: string): GpsTriggerVisitedStore {
    let stores = states.get(root);
    if (!stores) {
        stores = new Map();
        states.set(root, stores);
    }
    let store = stores.get(storageKey);
    if (!store) {
        store = new GpsTriggerVisitedStore(storage, storageKey);
        stores.set(storageKey, store);
    }
    return store;
}
